import React from 'react';
import { SvgIconProps } from '@mui/material';

export const BookmarkFilledIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="17"
        height="22"
        viewBox="0 0 17 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.5 13.9412L16 21V5.70588V3.35294C16 2.05345 14.8807 1 13.5 1H3.5C2.11929 1 1 2.05345 1 3.35294V11.5882V21L8.5 13.9412Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default BookmarkFilledIcon;
